export default __webpack_public_path__ + "static/media/christmas2.1eb30431.png";